import React, { Component, Fragment } from "react";
import {
  FormGroup,
  ControlLabel,
  Row,
  Col,
  FormControl,
  Checkbox,
} from "react-bootstrap";
import LoaderButton from "../../src/Component/LoaderButton";
import { fillSomervilleExpungmentForm } from "../libs/API";

class SomervilleExpungement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      caseNumber: "",
      expDate: "",
      dateExpunged: "",
      expungementOrder: "",
      isAppendFile: "",
      isPrependExistingFile: "",
    };
    // console.log("AberdeenExpungement popup props", props);
  }

  async componentDidMount() {
    const selectedRow = this.props.selectedRow;
    const caseNumber = selectedRow[0]["Case Number"] || "";
    this.setState({
      caseNumber,
    });
  }

  handleSomervilleExpungementSubmit = async (e) => {
    e.preventDefault();
    this.setState({ isLoading: true });
    const jObject = {
      ExpOrder: this.state.expungementOrder,
      Name: this.state.name,
      ExpDate: this.props.getFormattedDate(new Date(this.state.expDate)),
      Case: this.state.caseNumber,
      "Date Expunged": this.props.getFormattedDate(
        new Date(this.state.dateExpunged)
      ),
    };

    const jArray = [];
    jArray.push(jObject);
    jArray.push({ fileId: this.props.selectedRow[0].FileId });
    const isAppendFile =
      this.state.isAppendFile === null || this.state.isAppendFile === ""
        ? false
        : true;
    const isPrependExistingFile =
      this.state.isPrependExistingFile === null ||
      this.state.isPrependExistingFile === ""
        ? false
        : true;
    // console.log(this.state.isPrependExistingFile, "hello");
    jArray.push({
      isAppendFile: isAppendFile,
      isPrependExistingFile: isPrependExistingFile,
    });

    fillSomervilleExpungmentForm(jArray)
      .then((data) => {
        if (data.status === 200) {
          // ✅ axios response has .status
          this.setState({ isLoading: false });
          this.props.closeParentPopup();
        }
      })
      .catch((err) => console.log(err));
  };

  render() {
    return (
      <Fragment>
        <form onSubmit={this.handleSomervilleExpungementSubmit}>
          <FormGroup controlId="caseNumber">
            <Row>
              <Col sm={4} componentClass={ControlLabel}>
                Case #:
              </Col>
              <Col sm={8}>
                <FormControl
                  className="input-box"
                  type="text"
                  required
                  readOnly
                  value={this.state.caseNumber}
                />
              </Col>
            </Row>
          </FormGroup>
          <FormGroup controlId="expDate">
            <Row>
              <Col sm={4} componentClass={ControlLabel}>
                Exp. Date:
              </Col>
              <Col sm={8}>
                <FormControl
                  className="input-box"
                  type="date"
                  onChange={(e) => this.setState({ expDate: e.target.value })}
                />
              </Col>
            </Row>
          </FormGroup>
          <FormGroup controlId="id">
            <Row>
              <Col sm={4} componentClass={ControlLabel}>
                Expungement Order#:
              </Col>
              <Col sm={8}>
                <FormControl
                  className="input-box"
                  type="text"
                  onChange={(e) =>
                    this.setState({ expungementOrder: e.target.value })
                  }
                />
              </Col>
            </Row>
          </FormGroup>
          <FormGroup controlId="expDate">
            <Row>
              <Col sm={4} componentClass={ControlLabel}>
                Date Expunged:
              </Col>
              <Col sm={8}>
                <FormControl
                  className="input-box"
                  type="date"
                  onChange={(e) =>
                    this.setState({ dateExpunged: e.target.value })
                  }
                />
              </Col>
            </Row>
          </FormGroup>

          <FormGroup>
            <Row>
              <Col sm={4}>
                <LoaderButton
                  block
                  bsClass="btn btn-outline-secondary"
                  disabled={this.state.isLoading}
                  type="submit"
                  isLoading={this.state.isLoading}
                  text="Expunge Record"
                  loadingText="Expunging Record..."
                />
              </Col>

              <Col sm={8}>
                <Checkbox
                  key={1}
                  onChange={(e) =>
                    this.setState({ isAppendFile: e.target.checked })
                  }
                >
                  {"   "} Append to Existing Expungement
                </Checkbox>
              </Col>
            </Row>
          </FormGroup>
          <FormGroup>
            <Row>
              <Col sm={4}></Col>
              <Col sm={8}>
                <Checkbox
                  key={1}
                  onChange={(e) =>
                    this.setState({
                      isPrependExistingFile: e.target.checked,
                    })
                  }
                >
                  {"   "} Expunge and retain file
                </Checkbox>
              </Col>
            </Row>
          </FormGroup>
        </form>
      </Fragment>
    );
  }
}

export default SomervilleExpungement;
